<script setup lang="ts">
import { InputNumberComponent } from '../../'
import type { FilterOperatorEnum } from '../../../types'

import CriteriaFieldCell from './CriteriaFieldCell.vue'
import CriteriaOperatorSelect from './CriteriaOperatorSelect.vue'
import { useNumericField } from './numeric-field.helper'

defineProps<{ placeholder?: string; size?: 'default' | 'large'; isDisabled?: boolean; precision?: number }>()

const operator = defineModel<FilterOperatorEnum | null>('operator', { default: null })
const valueModel = defineModel<number | null>('value', { default: null })
const value = useNumericField(valueModel)
</script>

<template>
  <CriteriaFieldCell>
    <CriteriaOperatorSelect v-model="operator" :size="size" :is-disabled="isDisabled" />
  </CriteriaFieldCell>
  <CriteriaFieldCell>
    <InputNumberComponent
      v-model="value"
      :precision="precision"
      :step="precision !== undefined ? 10 ** -precision : 1"
      :is-disabled="isDisabled"
      :size="size"
      :placeholder="placeholder ?? '0'"
    >
      <template v-if="$slots.suffix" #suffix><slot name="suffix" /></template>
    </InputNumberComponent>
  </CriteriaFieldCell>
</template>
